
import { useState } from 'react';
import { booksData } from '../../../mocks/books';
import { Link } from 'react-router-dom';

const FeaturedBooks = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const booksPerView = 3;
  const maxIndex = Math.max(0, booksData.length - booksPerView);

  const handleNext = () => {
    setCurrentIndex((prev) => Math.min(prev + 1, maxIndex));
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => Math.max(prev - 1, 0));
  };

  const visibleBooks = booksData.slice(currentIndex, currentIndex + booksPerView);

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-12">
          <h2 className="text-4xl font-serif font-bold text-[#1B3A52] mb-4 md:mb-0">
            Published Works
          </h2>
          <p className="text-sm text-gray-600 max-w-md text-right">
            Discover books that inspire faith, deepen understanding, and bring you closer to God's heart.
          </p>
        </div>

        <div className="relative">
          {/* Navigation Arrows */}
          <div className="flex items-center gap-4">
            {/* Left Arrow */}
            <button
              onClick={handlePrev}
              disabled={currentIndex === 0}
              className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center transition-all cursor-pointer ${
                currentIndex === 0
                  ? 'bg-gray-100 text-gray-300 cursor-not-allowed'
                  : 'bg-[#1B3A52] text-white hover:bg-[#2a5270]'
              }`}
            >
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>

            {/* Books Grid */}
            <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-8">
              {visibleBooks.map((book) => (
                <Link
                  to="/books"
                  key={book.id}
                  className="bg-[#FDFBF7] rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer"
                >
                  {/* Book Cover */}
                  <div className="relative h-96 bg-gradient-to-br from-[#F5E6D3] to-[#E8D4B8] p-8 flex items-center justify-center">
                    <img
                      src={book.coverImage}
                      alt={book.title}
                      className="h-full w-auto object-contain drop-shadow-2xl group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>

                  {/* Book Info */}
                  <div className="p-6 text-center">
                    <h3 className="text-xl font-serif font-bold text-[#1B3A52] mb-2">
                      {book.title}
                    </h3>
                    <p className="text-sm text-gray-500">
                      by Pastor Don R Vining
                    </p>
                  </div>
                </Link>
              ))}
            </div>

            {/* Right Arrow */}
            <button
              onClick={handleNext}
              disabled={currentIndex >= maxIndex}
              className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center transition-all cursor-pointer ${
                currentIndex >= maxIndex
                  ? 'bg-gray-100 text-gray-300 cursor-not-allowed'
                  : 'bg-[#1B3A52] text-white hover:bg-[#2a5270]'
              }`}
            >
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>
          </div>

          {/* Pagination Dots */}
          <div className="flex justify-center gap-2 mt-8">
            {Array.from({ length: maxIndex + 1 }).map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  index === currentIndex ? 'bg-[#D4AF37] w-6' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedBooks;
